import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { observable } from 'mobx'
import { getDocumentTemplateTypeText, DownloadDocumentType } from '../../../Model/DownloadDocumentType'
import EnumHelpers from '../../../Helpers/EnumHelpers'
import HttpActionsService from '../../../Services/HttpActionsService'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { Questionnaire } from '../../../Model/Questionnaire'

export interface IDownloadDocumentProps {
    className?: string
    httpActionsService?: HttpActionsService
    localizationStore?: LocalizationStore
    questionnaire: Questionnaire
}

@inject('httpActionsService')
@inject('localizationStore')

@observer
export default class DownloadDocument extends React.Component<IDownloadDocumentProps> {

    @observable
    downloadType: DownloadDocumentType = 0

    downloadBtnClick(e: any) {
        const { httpActionsService, questionnaire } = this.props
        httpActionsService!.downloadDocument(questionnaire.id, this.downloadType)
    }

    downloadDocumentTypeChange(e: any) {
        this.downloadType = e.target.value
    }

    render() {

        const { className } = this.props

        return (
            <div className={className}>
                <select 
                    onChange={(e) => { this.downloadDocumentTypeChange(e) }}
                    className="form-control col-6 select"
                >
                    {
                        EnumHelpers.toKeyValueArray(DownloadDocumentType).map(x => {
                            return (
                                <option key={x.value} value={x.value}>
                                    {getDocumentTemplateTypeText(x.key)}
                                </option>
                            ) 
                        })
                    }
                </select>
                <button 
                    className="btn btn-success submit" 
                    onClick={(e) => { this.downloadBtnClick(e) }}
                >
                    {this.props.localizationStore!.t('download')}
                </button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/DownloadDocument.tsx